import React from 'react';
import { cn } from '../../../helpers/utils';

interface TextAreaProps {
  id?: string;
  placeholder?: string;
  size?: 'small' | 'medium' | 'large';
  error?: string;
  value?: string;
  containerClassName?: string;
  label?: string;
  labelClassName?: string;
  inputClassName?: string;
  inputBackground?: string;
  disabled?: boolean;
  danger?: boolean;
  showMessageError?: boolean;
  required?: boolean;
  maxLength?: number;
  rows?: number;
  showIndicator?: boolean;
  dynamicHeight?: boolean;
  infoField?: string;
  disabledClassName?: string;
}

const TextArea = ({
  id,
  placeholder,
  label,
  labelClassName,
  inputClassName,
  danger,
  showMessageError = true,
  required,
  maxLength = null,
  rows,
  size = 'small',
  value = '',
  disabled = false,
  error = '',
  containerClassName = '',
  inputBackground = 'bg-reliableBlack3',
  dynamicHeight = false,
  infoField,
  disabledClassName = '',
  ...props
}: TextAreaProps & React.ComponentProps<'textarea'>) => {
  const sizeClassName = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
  };

  const defaultStyling = `w-full ${
    dynamicHeight ? 'h-auto' : rows === 1 ? ' h-[45px]' : 'h-[109px]'
  } outline-none ${inputBackground} text-reliableBlack border-b border-reliableBlack30 placeholder:text-reliableBlack60 focus:border-reliableBlack60 ${
    disabled ? cn('bg-reliableBlack10 text-reliableBlack5', disabledClassName) : ''
  }`;

  const noResizeStyle = {
    resize: 'none',
  } as React.CSSProperties;

  return (
    <div className={containerClassName}>
      <div className="relative">
        {label && (
          <label className={labelClassName}>
            {label}
            {required && <span className="text-red-500"> *</span>}
          </label>
        )}

        <div className="relative leading-none">
          {dynamicHeight ? (
            <textarea
              id={id}
              placeholder={placeholder}
              value={value}
              maxLength={maxLength}
              disabled={disabled}
              style={noResizeStyle}
              rows={rows}
              className={`${defaultStyling} ${sizeClassName[size]} ${inputClassName} ${
                danger ? 'border-supportiveRed' : ''
              } ${error ? 'border-shadeRed' : ''}`}
              {...props}
            />
          ) : (
            <textarea
              id={id}
              placeholder={placeholder}
              value={value}
              maxLength={maxLength}
              disabled={disabled}
              style={noResizeStyle}
              className={`${defaultStyling} ${sizeClassName[size]} ${inputClassName} ${
                danger ? 'border-supportiveRed' : ''
              } ${error ? 'border-shadeRed' : ''}`}
              {...props}
            />
          )}
        </div>
      </div>

      {showMessageError ? (
        error ? (
          <div className="flex items-center gap-5.67px">
            <span className="text-supportiveRed text-[14px] leading-20px font-400">{error}</span>
          </div>
        ) : infoField ? (
          <span className="text-xs text-reliableBlack70">{infoField}</span>
        ) : (
          ''
        )
      ) : null}
    </div>
  );
};

export default TextArea;
